import Axios, { AxiosRequestConfig } from 'axios';
import localforage from 'localforage';

import { LocalStorageKeyEnum } from '../enums/LocalStorageKey';

const defaultOptions: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30000
};

export const axiosInstance = Axios.create(defaultOptions);

axiosInstance.interceptors.request.use(async (req) => {
  const accessToken = await localforage.getItem<string | null | undefined>(
    LocalStorageKeyEnum['TOKEN']
  );
  if (accessToken) {
    req.headers.Authorization = `Bearer ${accessToken}`;
  }
  return req;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    throw error;
  }
);
